var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SelectSingle from './SelectSingle';
import SelectMultiple from './SelectMultiple';
import '../../css/clydeSelect.css';
var ClydeSelect = function (props) {
    var multiple = props.multiple, rest = __rest(props, ["multiple"]);
    return multiple
        ? React.createElement(SelectMultiple, __assign({}, rest))
        : React.createElement(SelectSingle, __assign({}, rest));
};
export default ClydeSelect;
// MARKER: AJC 06/03/20 This is a good first pass but SelectSingle can use more work.
// Currently the method of opening the component locks you into that input device:
//   - Opening with mouse click makes it impossible to navigate to options with the keyboard
//   - Opening with keypress makes it so that clicking off the component does not auto collapse
// Additionally the normal select props `autofocus` and `form` are not yet included
